// GroupIcons.jsx - Reusable SVG icon components

export const CopyLinkIcon = ({ width = "18px", height = "18px", className = "" }) => (
  <svg 
    stroke="currentColor" 
    strokeWidth="0.5" 
    width={width} 
    height={height} 
    viewBox="0 0 15 15" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M9.31802 0.974873C9.94222 0.350672 10.7888 0 11.6716 0C13.5098 0 15 1.49019 15 3.32843C15 4.21118 14.6493 5.05778 14.0251 5.68198L10.8536 8.85355L10.1464 8.14645L13.318 4.97487C13.7547 4.53821 14 3.94596 14 3.32843C14 2.04247 12.9575 1 11.6716 1C11.054 1 10.4618 1.24532 10.0251 1.68198L6.85355 4.85355L6.14645 4.14645L9.31802 0.974873ZM10.8536 4.85355L4.85355 10.8536L4.14645 10.1464L10.1464 4.14645L10.8536 4.85355ZM4.85355 6.85355L1.68198 10.0251C1.24532 10.4618 1 11.054 1 11.6716C1 12.9575 2.04247 14 3.32843 14C3.94596 14 4.53821 13.7547 4.97487 13.318L8.14645 10.1464L8.85355 10.8536L5.68198 14.0251C5.05778 14.6493 4.21118 15 3.32843 15C1.49019 15 0 13.5098 0 11.6716C0 10.7888 0.350673 9.94222 0.974874 9.31802L4.14645 6.14645L4.85355 6.85355Z" 
      fill="#000000"
    />
  </svg>
);

export const LeaveGroupIcon = ({ width = "20px", height = "20px", className = "" }) => (
  <svg 
    fill="none" 
    stroke="currentColor" 
    width={width} 
    height={height} 
    viewBox="0 0 24 24" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path 
      d="M14 7.63636L14 4.5C14 4.22386 13.7761 4 13.5 4L4.5 4C4.22386 4 4 4.22386 4 4.5L4 19.5C4 19.7761 4.22386 20 4.5 20L13.5 20C13.7761 20 14 19.7761 14 19.5L14 16.3636" 
      stroke="#000000" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M10 12L21 12M21 12L18.0004 8.5M21 12L18 15.5" 
      stroke="#000000" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

export const ReportIcon = ({ width = "20px", height = "20px", className = "" }) => (
  <svg 
    fill="currentColor" 
    stroke="currentColor" 
    strokeWidth="0.2" 
    width={width} 
    height={height} 
    viewBox="0 0 24 24" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path 
      fillRule="evenodd" 
      d="M16,2 C16.2652165,2 16.5195704,2.10535684 16.7071068,2.29289322 L21.7071068,7.29289322 C21.8946432,7.4804296 22,7.73478351 22,8 L22,15 C22,15.2339365 21.9179838,15.4604694 21.7682213,15.6401844 L16.7682213,21.6401844 C16.5782275,21.868177 16.2967798,22 16,22 L8,22 C7.73478351,22 7.4804296,21.8946432 7.29289322,21.7071068 L2.29289322,16.7071068 C2.10535684,16.5195704 2,16.2652165 2,16 L2,8 C2,7.73478351 2.10535684,7.4804296 2.29289322,7.29289322 L7.29289322,2.29289322 C7.4804296,2.10535684 7.73478351,2 8,2 L16,2 Z M15.5857864,4 L8.41421356,4 L4,8.41421356 L4,15.5857864 L8.41421356,20 L15.5316251,20 L20,14.6379501 L20,8.41421356 L15.5857864,4 Z M12,16 C12.5522847,16 13,16.4477153 13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 C11,16.4477153 11.4477153,16 12,16 Z M12,6 C12.5522847,6 13,6.44771525 13,7 L13,13 C13,13.5522847 12.5522847,14 12,14 C11.4477153,14 11,13.5522847 11,13 L11,7 C11,6.44771525 11.4477153,6 12,6 Z"
    />
  </svg>
);
export const GroupMessageIcon = ({ width = "25px", height = "25px", className = "" }) => (
  <svg 
    // fill="#000000" 
    fill="currentColor" 
    width={width} 
    height={height} 
    viewBox="0 0 24 24" id="messenger" 
    data-name="Flat Color" 
    xmlns="http://www.w3.org/2000/svg" 
    className={`icon flat-color ${className}`}
    >
    <path 
      id="primary" 
      d="M19.07,4.93A10,10,0,0,0,3,16.26L2,20.8a1,1,0,0,0,.27.91A1,1,0,0,0,3.2,22L7.74,21A9.89,9.89,0,0,0,12,22a10.61,10.61,0,0,0,1.85-.17,10,10,0,0,0,5.22-16.9Z" 
      style={{ fill: 'rgb(0, 0, 0)' }}/>
      <path 
      id="secondary" 
      d="M8,14a1,1,0,0,1-.55-1.83l3-2a1,1,0,0,1,1.26.12l1.42,1.42,2.32-1.54a1,1,0,1,1,1.1,1.66l-3,2a1,1,0,0,1-1.26-.12l-1.42-1.42L8.55,13.83A.94.94,0,0,1,8,14Z" 
      style={{ fill: 'rgb(44, 169, 188)' }}/>
    </svg>
);
export const EditIcon = ({ width = "25px", height = "25px", className = "" }) => (
  <svg 
    // fill="#000000" 
    fill="currentColor" 
    width={width} 
    height={height} 
    viewBox="0 -32 576 576" id="messenger" 
    data-name="Flat Color" 
    xmlns="http://www.w3.org/2000/svg" 
    className={`icon flat-color ${className}`}
    >
    <path 
      id="primary" 
      d="M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z" 
      style={{ fill: 'rgba(146, 146, 146, 1)' }}/>

    </svg>
);

export const DeleteIcon = ({ width = "25px", height = "25px", className = "" }) => (
  <svg 
    fill="#000000" 
    width={width} 
    height={height} 
    viewBox="0 0 24 24" id="messenger" 
    data-name="Flat Color" 
    xmlns="http://www.w3.org/2000/svg" 
    className={`icon flat-color ${className}`}
    >
    <path 
      id="primary" 
      d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
      />

    </svg>
);

export const CopyIcon = ({ width = "20px", height = "20px", className = "" }) => (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path 
      d="M5.11765 15.7059C3.9481 15.7059 3 14.7578 3 13.5882V5.11765C3 3.9481 3.9481 3 5.11765 3H13.5882C14.7578 3 15.7059 3.9481 15.7059 5.11765V5.64706" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <rect 
      x="8.29413" 
      y="8.29412" 
      width="12.7059" 
      height="12.7059" 
      rx="2" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);
export const UpIcon = ({ width = "20px", height = "20px", className = "" }) => (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 52 52" 
    fill="#000000" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path 
      d="M43.7,38H8.3c-1,0-1.7-1.3-0.9-2.2l17.3-21.2c0.6-0.8,1.9-0.8,2.5,0l17.5,21.2C45.4,36.7,44.8,38,43.7,38z" 
    />
  </svg>
);
export const DownIcon = ({ width = "20px", height = "20px", className = "" }) => (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 52 52" 
    fill="#000" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path 
      d="M8.3,14h35.4c1,0,1.7,1.3,0.9,2.2L27.3,37.4c-0.6,0.8-1.9,0.8-2.5,0L7.3,16.2C6.6,15.3,7.2,14,8.3,14z" 
    />
  </svg>
);

export const ShareScreenIcon = ({ width = "38px", height = "38px", className = "" }) => (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 28 28" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fill="white" fillRule="nonzero">
        <path 
          d="M23.75,4.99939 C24.9926,4.99939 26,6.00675 26,7.24939 L26,20.75 C26,21.9926 24.9926,23 23.75,23 L4.25,23 C3.00736,23 2,21.9927 2,20.75 L2,7.24939 C2,6.00675 3.00736,4.99939 4.25,4.99939 L23.75,4.99939 Z M23.75,6.49939 L4.25,6.49939 C3.83579,6.49939 3.5,6.83518 3.5,7.24939 L3.5,20.75 C3.5,21.1642 3.83579,21.5 4.25,21.5 L23.75,21.5 C24.1642,21.5 24.5,21.1642 24.5,20.75 L24.5,7.24939 C24.5,6.83518 24.1642,6.49939 23.75,6.49939 Z M13.9975,8.62102995 C14.1965,8.62102995 14.3874,8.69998 14.5281,8.8407 L17.7826,12.0952 C18.0755,12.3881 18.0755,12.863 17.7826,13.1559 C17.4897,13.4488 17.0148,13.4488 16.7219,13.1559 L14.7477,11.1817 L14.7477,18.6284 C14.7477,19.0426 14.412,19.3784 13.9977,19.3784 C13.5835,19.3784 13.2477,19.0426 13.2477,18.6284 L13.2477,11.1835 L11.2784,13.1555 C10.9858,13.4486 10.5109,13.4489 10.2178,13.1562 C9.92469,12.8636 9.92436,12.3887 10.217,12.0956 L13.467,8.84107 C13.6077,8.70025 13.7985,8.62102995 13.9975,8.62102995 Z"
        />
      </g>
    </g>
  </svg>
);

export const ScreenIcon = ({ width = "40px", height = "40px", className = "" }) => (
  <svg 
    fill="#000000" 
    width={width} 
    height={height} 
    viewBox="-2 -3 24 24" 
    xmlns="http://www.w3.org/2000/svg" 
    preserveAspectRatio="xMinYMin"
    className={className}
  >
    <path 
      d='M3 2a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3zm0-2h14a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3zm4 16h6a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2z'
    />
  </svg>
);

export const CallIcon = ({ width = "18px", height = "18px", className = "" }) => (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 32 32" 
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    stroke="currentColor"
  >
    <path 
      d="M23.407 30.394c-2.431 0-8.341-3.109-13.303-9.783-4.641-6.242-6.898-10.751-6.898-13.785 0-2.389 1.65-3.529 2.536-4.142l0.219-0.153c0.979-0.7 2.502-0.927 3.086-0.927 1.024 0 1.455 0.599 1.716 1.121 0.222 0.442 2.061 4.39 2.247 4.881 0.286 0.755 0.192 1.855-0.692 2.488l-0.155 0.108c-0.439 0.304-1.255 0.869-1.368 1.557-0.055 0.334 0.057 0.684 0.342 1.068 1.423 1.918 5.968 7.55 6.787 8.314 0.642 0.6 1.455 0.685 2.009 0.218 0.573-0.483 0.828-0.768 0.83-0.772l0.059-0.057c0.048-0.041 0.496-0.396 1.228-0.396 0.528 0 1.065 0.182 1.596 0.541 1.378 0.931 4.487 3.011 4.487 3.011l0.05 0.038c0.398 0.341 0.973 1.323 0.302 2.601-0.695 1.327-2.85 4.066-5.079 4.066zM9.046 2.672c-0.505 0-1.746 0.213-2.466 0.728l-0.232 0.162c-0.827 0.572-2.076 1.435-2.076 3.265 0 2.797 2.188 7.098 6.687 13.149 4.914 6.609 10.532 9.353 12.447 9.353 1.629 0 3.497-2.276 4.135-3.494 0.392-0.748 0.071-1.17-0.040-1.284-0.36-0.241-3.164-2.117-4.453-2.988-0.351-0.238-0.688-0.358-0.999-0.358-0.283 0-0.469 0.1-0.532 0.14-0.104 0.111-0.39 0.405-0.899 0.833-0.951 0.801-2.398 0.704-3.424-0.254-0.923-0.862-5.585-6.666-6.916-8.459-0.46-0.62-0.641-1.252-0.538-1.877 0.187-1.133 1.245-1.866 1.813-2.26l0.142-0.099c0.508-0.363 0.4-1.020 0.316-1.242-0.157-0.414-1.973-4.322-2.203-4.781-0.188-0.376-0.336-0.533-0.764-0.533z" 
      fill="#ffffff"
    />
  </svg>
);

export const EndCallIcon = ({ width = "18px", height = "18px", className = "" }) => (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 48 48" 
    version="1" 
    xmlns="http://www.w3.org/2000/svg" 
    // enableBackground="new 0 0 48 48"
    className={className}
  >
    <path 
      // fill="#F44336" 
      d="M43.5,16.8l-2.3-2.3c-8.1-7.9-27.5-6.8-34.5,0l-2.3,2.3c-0.6,0.6-0.6,1.6,0,2.3l4.6,4.5 c0.6,0.6,1.7,0.6,2.3,0l5.1-4.9L16,13.4c1.6-1.6,14.4-1.6,16,0l-0.3,5.5l4.9,4.7c0.6,0.6,1.7,0.6,2.3,0l4.6-4.5 C44.2,18.4,44.2,17.4,43.5,16.8z"
    />
    <g 
    // fill="#B71C1C"
    >
      <polygon points="24,40.5 16,31 32,31"/>
      <rect x="21" y="24" width="6" height="7.5"/>
    </g>
  </svg>
);

export const VolumeOffIcon = ({ width = "18px", height = "18px", className = "" }) => (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 16 16" 
    xmlns="http://www.w3.org/2000/svg" 
    fill="#000000"
    className={className}
  >
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M1.5 5h2.79l3.86-3.83.85.35v13l-.85.33L4.29 11H1.5l-.5-.5v-5l.5-.5zm3.35 5.17L8 13.31V2.73L4.85 5.85 4.5 6H2v4h2.5l.35.17zm9.381-4.108l.707.707L13.207 8.5l1.731 1.732-.707.707L12.5 9.207l-1.732 1.732-.707-.707L11.793 8.5 10.06 6.77l.707-.707 1.733 1.73 1.731-1.731z"
    />
  </svg>
);


export const VolumeIcon = ({ width = "18px", height = "18px", className = "" }) => (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 16 16" 
    xmlns="http://www.w3.org/2000/svg" 
    fill="#000000"
    className={className}
  >
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M1.5 4.83h2.79L8.15 1l.85.35v13l-.85.33-3.86-3.85H1.5l-.5-.5v-5l.5-.5zM4.85 10L8 13.14V2.56L4.85 5.68l-.35.15H2v4h2.5l.35.17zM15 7.83a6.97 6.97 0 0 1-1.578 4.428l-.712-.71A5.975 5.975 0 0 0 14 7.83c0-1.4-.48-2.689-1.284-3.71l.712-.71A6.971 6.971 0 0 1 15 7.83zm-2 0a4.978 4.978 0 0 1-1.002 3.004l-.716-.716A3.982 3.982 0 0 0 12 7.83a3.98 3.98 0 0 0-.713-2.28l.716-.716c.626.835.997 1.872.997 2.996zm-2 0c0 .574-.16 1.11-.44 1.566l-.739-.738a1.993 1.993 0 0 0 .005-1.647l.739-.739c.276.454.435.988.435 1.558z"
    />
  </svg>
);


export const UnmuteIcon = ({ width = "18px", height = "18px", className = "" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M11.4438 15.6158C9.61449 15.3535 8.16496 13.8474 7.87983 11.9127C7.62814 10.2049 7.62833 8.4647 7.88002 6.75693C8.16501 4.82323 9.61225 3.31511 11.4402 3.04907L11.5523 3.03274C11.8523 2.98909 12.1565 2.98909 12.4564 3.03274L12.5532 3.04682C14.3897 3.31412 15.8429 4.8308 16.1263 6.77402C16.3738 8.47068 16.374 10.1989 16.1265 11.8956C15.8429 13.8398 14.3874 15.3544 12.5495 15.618L12.4498 15.6323C12.1542 15.6747 11.8546 15.6747 11.559 15.6323L11.4438 15.6158Z"
      fill="#363853"
      fillOpacity="0.15"
    />
    <path
      d="M19.75 11.4531C19.75 15.9259 16.3213 19.6285 12 19.6285C7.67872 19.6285 4.25 15.9259 4.25 11.4531M11.25 18.8785V21M12.75 18.8785V21"
      stroke="#363853"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const MuteIcon = ({ width = "18px", height = "18px", className = "" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M15.6389 3.94685C14.7676 2.90943 13.4608 2.25 12 2.25C9.37665 2.25 7.25 4.37665 7.25 7V11C7.25 11.4097 7.30186 11.8072 7.39937 12.1864L15.6389 3.94685Z"
      fill="currentColor"
    />
    <path
      d="M9.42322 14.991L8.3443 16.0699C9.37225 16.8124 10.635 17.25 12 17.25C15.4518 17.25 18.25 14.4518 18.25 11V10C18.25 9.58579 18.5858 9.25 19 9.25C19.4142 9.25 19.75 9.58579 19.75 10V11C19.75 15.0272 16.6783 18.3369 12.75 18.7142V21C12.75 21.4142 12.4142 21.75 12 21.75C11.5858 21.75 11.25 21.4142 11.25 21V18.7142C9.76088 18.5712 8.39485 18.0068 7.27257 17.1416L5.70711 18.7071C5.31658 19.0976 4.68342 19.0976 4.29289 18.7071C3.90237 18.3166 3.90237 17.6834 4.29289 17.2929L5.85836 15.7274C4.84983 14.4192 4.25 12.7796 4.25 11V10C4.25 9.58579 4.58579 9.25 5 9.25C5.41421 9.25 5.75 9.58579 5.75 10V11C5.75 12.365 6.18757 13.6277 6.93008 14.6557L18.2929 3.29289C18.6834 2.90237 19.3166 2.90237 19.7071 3.29289C20.0976 3.68342 20.0976 4.31658 19.7071 4.70711L16.75 7.66421V11C16.75 13.6234 14.6234 15.75 12 15.75C11.0502 15.75 10.1655 15.4712 9.42322 14.991Z"
      fill="currentColor"
    />
  </svg>
);

export const CheckCircleIcon = ({ width = "24px", height = "24px", className = "" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle cx="12" cy="12" r="10" fill="#2ecc71" />
    <path
      d="M16 7l-6 6-2.5-2.5-2.125 2.1 2.5 2.5 2 2 0.125 0.1 8.125-8.1-2.125-2.1z"
      fill="#ecf0f1"
    />
  </svg>
);

export const XCircleIcon = ({ width = "24px", height = "24px", className = "" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 16C2 8.26801 8.26801 2 16 2C23.732 2 30 8.26801 30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16ZM13.172 11.7574C12.7814 11.3668 12.1483 11.3668 11.7577 11.7574C11.3672 12.1479 11.3672 12.7811 11.7577 13.1716L14.5862 16L11.7577 18.8284C11.3672 19.219 11.3672 19.8521 11.7577 20.2427C12.1483 20.6332 12.7814 20.6332 13.172 20.2427L16.0004 17.4142L18.8288 20.2427C19.2193 20.6332 19.8525 20.6332 20.243 20.2427C20.6335 19.8521 20.6335 19.219 20.243 18.8284L17.4146 16L20.243 13.1716C20.6336 12.7811 20.6336 12.1479 20.243 11.7574C19.8525 11.3668 19.2193 11.3668 18.8288 11.7574L16.0004 14.5858L13.172 11.7574Z"
      fill="#e72626"
    />
  </svg>
);